export default __webpack_public_path__ + "static/media/ic-practice-test.c8fba0a3.svg";